import Vue from "vue";
import VueRouter from "vue-router";
import Loading from "../views/Loading";
import Home from "../views/Home.vue";
import Story1 from "../views/Story1";
import Story2 from "../views/Story2";
import Story3 from "../views/Story3";
import Story4 from "../views/Story4";
import Story5 from "../views/Story5";
import NotFound from "../views/NotFound";
import AboutUs from "../views/AboutUs";
import Projects from "../views/Projects";
import Contact from "../views/Contact";
import EbaTV from "../views/EbaTV";
import Privacy from "../views/Privacy";
import Kvkk from "../views/Kvkk";
import PersonalData from "../views/PersonalData";
import ClarificationText from "../views/ClarificationText";
import WaterAcademy from "../views/WaterAcademy";
import Documentary25Litre from "../views/Documentary25Litre";
import LegalTerms from "../views/LegalTerms";
import CookiePolicy from "../views/CookiePolicy";
import Hayrats from "../views/Hayrats";
import QuantumMax from "../views/QuantumMax";
import TechnicianFlow from "../views/TechnicianFlow";
import Tskb from "../views/Tskb";
import InstagramKvkk from "../views/InstagramKvkk";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Story1",
    component: Story1
  },
  {
    path: "/sendesozver",
    name: "WaterPrint",
    component: Home
  },
  {
    path: "/loading",
    name: "Load",
    component: Loading
  },
  {
    path: "/01",
    name: "Story1",
    component: Story1
  },
  {
    path: "/02",
    name: "Story2",
    component: Story2
  },
  {
    path: "/03",
    name: "Story3",
    component: Story3
  },
  {
    path: "/04",
    name: "Story4",
    component: Story4
  },
  {
    path: "/05",
    name: "Story5",
    component: Story5
  },
  {
    path: "/hakkimizda",
    name: "AboutUs",
    component: AboutUs
  },
  {
    path: "/projeler",
    name: "Projects",
    props: true,
    component: Projects
  },
  {
    path: "/projeler/:project",
    name: "Projects",
    props: true,
    component: Projects
  },
  {
    path: "/25litre",
    name: "Documentary25Litre",
    component: Documentary25Litre
  },
  {
    path: "/belgesele-ozel",
    name: "Documentary25Litre",
    component: Documentary25Litre
  },
  {
    path: "/belgesele-ozel?gclid=Cj0KCQiA5bz-BRD-ARIsABjT4nh24grrfDR9_3gNfoCjkh9PTXchM4ASzJHaKpaZr6oWCgJ42A8FvJsaAgSkEALw_wcB",
    name: "Documentary25Litre",
    component: Documentary25Litre
  },
  {
    path: "/iletisim",
    name: "Contact",
    component: Contact
  },
  {
    path: "/eba-tv",
    name: "EbaTV",
    component: EbaTV
  },
  {
    path: "/gizlilik",
    name: "Privacy",
    component: Privacy
  },
  /*{
    path: "/kvkk",
    name: "Kvkk",
    component: Kvkk,
  },*/
  {
    path: "/acik-riza-formu",
    name: "PersonalData",
    component: PersonalData
  },
  {
    path: "/aydinlatma-metni",
    name: "ClarificationText",
    component: ClarificationText
  },
  {
    path: "/su-akademisi",
    name: "WaterAcademy",
    component: WaterAcademy
  },
  {
    path: "/cerez-politikasi",
    name: "CookiePolicy",
    component: CookiePolicy
  },
  {
    path: "/hukuki-sartlar",
    name: "LegalTerms",
    component: LegalTerms
  },
  {
    path: "/rb-instagram-hatti-aydinlatma-bildirimi",
    name: "InstagramKvkk",
    component: InstagramKvkk
  },
  {
    path: "/hayratlar",
    name: "Hayrats",
    component: Hayrats
  },
  {
    path: "/finishin-surprizi-var",
    name: "QuantumMax",
    component: QuantumMax
  },
  {
    path: "/sudan-gecirmeden-temizle",
    name: "TeknisyenAkisi",
    component: TechnicianFlow
  },
  {
    path: "/tskb",
    name: "tskb",
    component: Tskb
  },
  {
    path: "/tasarrufsozu",
    redirect: '/'
  },
  {
    path: "/tasarrufsozu/*",
    redirect: '/'
  },
  {
    path: "*",
    name: "404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: '/',
  routes
});

export default router;

export const strict = false;
